import "react";
import { useState } from "react";
import LearnMoreModal from "./components/LearnMoreModal";
import PremiumFeatures from "./components/PremiumFeatures";
import AppScreenshots from "./components/AppScreenshots";
import DemoVideo from "./components/DemoVideo";
import ComingSoon from "./components/ComingSoon";
import Footer from "./components/Footer";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./components/LanguageSelector";
import ThemeSelector from "./components/ThemeSelector";

export default function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow-sm fixed w-full top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="h-16">
            <div className="flex justify-between items-center h-full">
              <div className="text-2xl font-bold text-green-600 dark:text-green-400">
                Quick Chef
              </div>
              <div className="flex gap-6 items-center">
                <div className="relative">
                  <LanguageSelector />
                </div>
                <div className="relative">
                  <ThemeSelector />
                </div>
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="text-gray-600 dark:text-gray-300 hover:text-green-600 dark:hover:text-green-400 transition"
                >
                  {t("header.learnMore")}
                </button>
                <a
                  href="https://play.google.com/store/apps/details?id=chef.quick"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-600 text-white px-6 py-2 rounded-full hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600 transition"
                >
                  {t("header.downloadNow")}
                </a>
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow pt-16">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-b from-green-50 to-white dark:from-gray-800 dark:to-gray-900">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-5xl font-bold text-gray-900 dark:text-white mb-6">
                {t("hero.title")}
                <span className="text-green-600 dark:text-green-400">
                  {" "}
                  {t("hero.titleHighlight")}
                </span>
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-300 mb-10">
                {t("hero.description")}
              </p>
              <div className="flex justify-center gap-4">
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="bg-white dark:bg-gray-800 text-green-600 dark:text-green-400 px-8 py-3 rounded-full border-2 border-green-600 dark:border-green-400 hover:bg-green-50 dark:hover:bg-gray-700 transition"
                >
                  {t("header.learnMore")}
                </button>
                <a
                  href="https://play.google.com/store/apps/details?id=chef.quick"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-600 dark:bg-green-500 text-white px-8 py-3 rounded-full hover:bg-green-700 dark:hover:bg-green-600 transition"
                >
                  {t("header.downloadNow")}
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* App Screenshots */}
        <AppScreenshots />

        {/* Premium Features */}
        <PremiumFeatures />

        {/* Demo Video */}
        <DemoVideo />

        {/* Coming Soon */}
        <ComingSoon />

        {/* Download Section */}
        <section className="py-20 bg-green-600 dark:bg-green-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h2 className="text-3xl font-bold text-white mb-6">
                {t("downloadSection.title")}
              </h2>
              <p className="text-xl text-green-100 mb-8">
                {t("downloadSection.description")}
              </p>

              <a
                href="https://play.google.com/store/apps/details?id=chef.quick"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-white dark:bg-gray-800 text-green-600 dark:text-green-400 px-6 py-3 rounded-lg hover:bg-green-50 dark:hover:bg-gray-700 transition shadow-lg"
              >
                <img
                  src="/images/google-play-logo.png"
                  alt="Google Play"
                  className="w-6 h-6 mr-3 object-contain"
                />
                <div className="text-left">
                  <div className="text-xs">{t("downloadSection.getItOn")}</div>
                  <div className="text-lg font-semibold">
                    {t("downloadSection.googlePlay")}
                  </div>
                </div>
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <Footer />

      {/* Learn More Modal */}
      <LearnMoreModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}
